import Image from "next/image";
import { type JSX } from "react";

import type {
  StoriesAssetPublicLink,
  StoryResultData,
} from "types/ContentHub/Stories";

import Button from "../../../atoms/Button";
import VideoIframe from "../../../atoms/VideoIframe";
import {
  getImageURLForCHPages,
  getLinkTargetValue,
} from "../../../utils/contentHubComponentsUtils";

export const getStoryImage = (
  imgList: StoriesAssetPublicLink[] = [],
): JSX.Element => {
  const storyResultImageURL = getImageURLForCHPages(imgList);
  if (!storyResultImageURL) return <></>;

  return (
    <div className="w-full mb-5">
      <Image
        src={storyResultImageURL}
        alt={"Story Image"}
        width={875}
        height={493}
        className="object-cover w-full h-full rounded-md"
      />
    </div>
  );
};

interface StoryResultComponentProps {
  storyResult: StoryResultData;
}

export default function StoryResult({
  storyResult,
}: Readonly<StoryResultComponentProps>) {
  return (
    <div
      className={`mx-auto bg-white w-full lg:w-(--article-container-width) max-lg:px-4`}
    >
      <div>
        {storyResult?.ResultsHeading && (
          <h2 className="text-ecolab-blue text-[26px] font-normal leading-[28px] mb-4 align-middle">
            {storyResult?.ResultsHeading}
          </h2>
        )}
        {storyResult?.ResultsBodyContent && (
          <div className="text-base font-normal text-charcoal-black space-y-1 wrap-anywhere richtext-content mb-5">
            <div
              dangerouslySetInnerHTML={{
                __html: storyResult?.ResultsBodyContent,
              }}
            ></div>
          </div>
        )}
        {storyResult?.StoryResult1VideoURL ? (
          <div className="w-full mb-5">
            <VideoIframe src={storyResult?.StoryResult1VideoURL} />
          </div>
        ) : (
          getStoryImage(
            storyResult?.storyResult1ToAsset?.results?.[0]?.assetToPublicLink
              ?.results,
          )
        )}
        {(storyResult?.ResultsPrimaryLink ||
          storyResult?.ResultsSecondaryLink) && (
          <div className="md:flex gap-x-2.5">
            {storyResult?.ResultsPrimaryLink && (
              <div className="mb-4">
                <Button
                  buttonType={"primary"}
                  className="inline-flex justify-center items-center m-0! max-sm:w-full"
                  field={{
                    value: {
                      href: storyResult?.ResultsPrimaryLink,
                      text:
                        storyResult?.ResultsPrimaryLinkText ||
                        storyResult?.ResultsPrimaryLink,
                      target: getLinkTargetValue(
                        storyResult?.ResultsPrimaryLink,
                      ),
                      linktype: "",
                    },
                  }}
                  tabIndex={0}
                  aria-label={
                    storyResult?.ResultsPrimaryLinkText ||
                    storyResult?.ResultsPrimaryLink
                  }
                />
              </div>
            )}
            {storyResult?.ResultsSecondaryLink && (
              <div className="mb-4">
                <Button
                  buttonType={"secondary"}
                  className="inline-flex justify-center items-center m-0! max-sm:w-full"
                  field={{
                    value: {
                      href: storyResult?.ResultsSecondaryLink,
                      text:
                        storyResult?.ResultsSecondaryLinkText ||
                        storyResult?.ResultsSecondaryLink,
                      target: getLinkTargetValue(
                        storyResult?.ResultsSecondaryLink,
                      ),
                      linktype: "",
                    },
                  }}
                  tabIndex={0}
                  aria-label={
                    storyResult?.ResultsSecondaryLinkText ||
                    storyResult?.ResultsSecondaryLink
                  }
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
